import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@components/atoms';
import { DialogTitle, DialogContent, DialogActions, Grid, Button, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    flex: {
        display: 'flex',
    }
}));

const DialogConfirm = (props) => {
    const { dialogProps, titleProps, title, contentProps, content, actionsProps, actions, okBtnText, cancelBtnText, onOkClickHandler, onCancelClickHandler } = props;
    const classes = useStyles();
    return (
        <Dialog {...dialogProps}>
            <DialogTitle {...titleProps}>{title}</DialogTitle>
            <DialogContent {...contentProps}>{content}</DialogContent>
            <DialogActions {...actionsProps}>{actions ? actions : (
                <Grid container justifyContent="center" alignItems="center" wrap="nowrap">
                    <Grid item xs={12} md={6} className={classes.flex} justifyContent="center">
                        <Button onClick={onOkClickHandler} variant="outlined">{okBtnText}</Button>
                    </Grid>
                    <Grid item xs={12} md={6} className={classes.flex} justifyContent="center">
                        <Button onClick={onCancelClickHandler} variant="outlined">{cancelBtnText}</Button>
                    </Grid>
                </Grid>
            )}</DialogActions>
        </Dialog>
    );
}

DialogConfirm.propTypes = {
    dialogProps: PropTypes.object,
    titleProps: PropTypes.object,
    title: PropTypes.any,
    contentProps: PropTypes.object,
    content: PropTypes.any,
    actionsProps: PropTypes.object,
    actions: PropTypes.any,
    onOkClickHandler: PropTypes.func.isRequired,
    onCancelClickHandler: PropTypes.func.isRequired,
    okBtnText: PropTypes.string,
    cancelBtnText: PropTypes.string,
};

DialogConfirm.defaultProps = {
    okBtnText: 'OK',
    cancelBtnText: 'Cancel',
};

export default DialogConfirm;
